<template>
  <v-row>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.code"
        :error-messages="error.code"
        label="Codice"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.title"
        :error-messages="error.title"
        label="Titolo"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.concert"
        :error-messages="error.concert"
        :model="concertModel"
        :extra-params="modelFk"
        item-text="short_title"
        item-value="id"
        :label="concertModel.verboseName"
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.people"
        :error-messages="error.people"
        :model="showPersonModel"
        :extra-params="modelFk"
        item-text="person__name"
        item-value="id"
        label="Musicisti"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.instruments"
        :error-messages="error.instruments"
        :model="showInstrumentModel"
        :extra-params="modelFk"
        item-text="instrument__name"
        item-value="id"
        label="Strumenti"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.bands"
        :error-messages="error.bands"
        :model="showBandModel"
        :extra-params="modelFk"
        item-text="band__name"
        item-value="id"
        label="Gruppi"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.place"
        :error-messages="error.place"
        :model="showPlaceModel"
        :extra-params="modelFk"
        item-text="place__name"
        item-value="id"
        label="Luogo"
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.start_date"
        :error-messages="error.start_date"
        label="Inizio"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.end_date"
        :error-messages="error.end_date"
        label="Fine"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col v-if="profile.is_staff" cols="12" sm="4">
      <v-text-field
        v-model="editedItem.sponsor"
        :error-messages="error.sponsor"
        label="Sponsor"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col v-if="profile.is_staff" cols="12" sm="4">
      <v-select
        v-model="editedItem.price"
        :error-messages="error.price"
        :items="[
          { value: 1, text: 'libero' },
          { value: 2, text: 'biglietto museo' },
          { value: 3, text: 'pagamento' },
        ]"
        label="Prezzo"
        :readonly="!profile.is_staff"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4">
      <v-select
        v-model="editedItem.kind"
        :error-messages="error.kind"
        :items="[
          { value: 1, text: 'evento pubblico' },
          { value: 2, text: 'prova' },
          { value: 3, text: 'accordatura' },
        ]"
        :readonly="!profile.is_staff"
        label="Tipologia"
      ></v-select>
    </v-col>
    <v-col v-if="profile.is_staff" cols="12" sm="4">
      <v-textarea
        v-model="editedItem.notes"
        :error-messages="error.notes"
        :readonly="!profile.is_staff"
        label="Note"
      ></v-textarea>
    </v-col>
    <v-col v-if="editedItem.concert" cols="12" sm="4">
      <p>Dettagli concerto collegato:</p>
      <ul>
        <li>Durata: {{ editedItem.concert__length }}</li>
        <li>Percorsi: {{ editedItem.concert__categories__names }}</li>
        <li>Descrizione: {{ editedItem.concert__description }}</li>
      </ul>
    </v-col>
    <v-col
      v-if="
        profile.is_staff &&
        editedItem.warnings &&
        editedItem.warnings.length > 0
      "
      cols="12"
      sm="4"
    >
      <ul>
        <li
          v-for="(warning, index) in editedItem.warnings"
          :key="index"
          class="red--text"
        >
          <template v-if="warning.type == 'outside_person_availability_range'">
            L'evento è all'infuori del range di disponibilità di
            {{ warning.person }}
          </template>
          <template v-else-if="warning.type == 'person_events_overlap'">
            L'evento si sovrappone ad altri eventi di
            {{ warning.person }}
          </template>
          <template
            v-else-if="warning.type == 'outside_instrument_availability_range'"
          >
            L'evento è all'infuori del range di disponibilità dello strumento
            {{ warning.instrument }}
          </template>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
import models from "@/models"

export default {
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    modelFk: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBandModel: models.ShowBand,
      concertModel: models.Concert,
      showInstrumentModel: models.ShowInstrument,
      showPersonModel: models.ShowPerson,
      showPlaceModel: models.ShowPlace,
    }
  },
}
</script>
